import { Field, useFormikContext } from 'formik'
import React from 'react'

import { Fieldset, Select } from '@fourthwall/components'
import { getCountriesOptions } from '@fourthwall/utils/dist/inputs'
import { routing } from '@utils/routing'

import type { ProductFormState } from '../../../SingleProduct.types'
import { HSCodeSelect } from './HSCodeSelect'

const countriesOptions = [
  { label: 'Select country', value: '' },
  ...getCountriesOptions({
    withMostPopular: true,
  }),
]

export type TaxFieldsProps = {
  showLearnMoreLinks?: boolean
}

export const TaxFields = React.memo(({ showLearnMoreLinks }: TaxFieldsProps) => {
  const { values } = useFormikContext<ProductFormState>()

  if (
    // manual HS Code entry is available for sell-something-i-have products
    values.fulfillmentService !== 'FULFILLED_BY_CREATOR' &&
    // and ship monk
    values.fulfillmentService !== 'SHIP_MONK' &&
    // and Cart Jazz
    values.fulfillmentService !== 'CART_JAZZ' &&
    // and bespoke
    values.manufacturingService !== 'FOURTHWALL_BESPOKE'
  ) {
    return null
  }

  return (
    <>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field
            component={Select}
            name="customsInformation.countryOfOrigin"
            label="Country product was manufactured in"
            options={countriesOptions}
            defaultValue=""
            suggestion={
              showLearnMoreLinks && (
                <>
                  Required for customs on international shipping.{' '}
                  <a href={routing.external.helpCenter.hsCodes} target="_blank" rel="noreferrer">
                    Learn more
                  </a>
                </>
              )
            }
          />
        </Fieldset.Item>
      </Fieldset.Row>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field
            component={HSCodeSelect}
            name="customsInformation.shortHsCode"
            label="Harmonized System (HS) code"
            suggestion={
              showLearnMoreLinks && (
                <>
                  Required for customs on international shipping.{' '}
                  <a href={routing.external.helpCenter.hsCodes} target="_blank" rel="noreferrer">
                    Learn more
                  </a>
                </>
              )
            }
          />
        </Fieldset.Item>
      </Fieldset.Row>
    </>
  )
})
